export type StaffInvoiceStatus = 'draft' | 'issued' | 'signed' | 'paid';

/**
 * Standard monthly working hours used to derive an hourly rate from an agreed
 * monthly salary (mirrors backend `STANDARD_MONTHLY_HOURS`, ADR-049):
 * hourly_rate = monthly_salary ÷ 168.
 */
export const STANDARD_MONTHLY_HOURS = 168;

export const STAFF_INVOICE_STATUSES: { value: StaffInvoiceStatus; label: string }[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'issued', label: 'Issued' },
  { value: 'signed', label: 'Signed' },
  { value: 'paid', label: 'Paid' },
];

export const staffInvoiceStatusLabel = (s: string): string =>
  STAFF_INVOICE_STATUSES.find((x) => x.value === s)?.label ?? s;

export function staffInvoiceStatusVariant(
  s: string,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'paid') return 'default';
  if (s === 'signed') return 'secondary';
  if (s === 'issued') return 'outline';
  return 'outline';
}
